import { useCallback } from "react"
import { useMandatePolling } from "./useMandatePolling"
import { useUpdateMandateEmbeddedLink } from "./useUpdateMandateEmbeddedLink"

export type MandateSign = {
  isSigning: boolean
  onMandateSign: (companyId: string, showToast?: boolean) => void
}

export const useMandateSign = (mandateId?: string | null): MandateSign => {
  const { startPolling, isPolling } = useMandatePolling()
  const [updateMandateLink, { loading: updatingMandateLink }] = useUpdateMandateEmbeddedLink()

  const isSigning = updatingMandateLink || isPolling

  const onMandateSign = useCallback(
    (companyId: string, showToast?: boolean) => {
      if (mandateId == null) throw Error("Mandate is not available")

      updateMandateLink({
        variables: { mandateId },
        onCompleted: () => {
          startPolling(companyId, showToast)
        },
      })
    },
    [startPolling, updateMandateLink, mandateId],
  )

  return { isSigning, onMandateSign }
}
